<template>
  <v-container fluid>
    <v-card class="elevation-2">
      <v-toolbar color="primary" dark flat>
        <v-icon class="mr-2">mdi-chart-bar</v-icon>
        <v-toolbar-title>Reports</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="text-center py-12">
        <v-icon size="80" color="grey lighten-2" class="mb-4">mdi-chart-box-outline</v-icon>
        <h3 class="text-h6 grey--text text--darken-1 mb-2">Informes del grupo</h3>
        <p class="grey--text mb-0">
          El contenido de los informes está pendiente de definir en un documento aparte.
        </p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'GrupoReports'
}
</script>
